(function() { module.exports = window["echarts"]; }());